/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import { InitiateNewCycleRequestDTO, Response } from "././index.d.ts";

export class Cycle<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description initiate new cycle
   *
   * @tags cycle
   * @name InitiateNewCycle
   * @request POST:/cycle
   * @secure
   */
  initiateNewCycle = (
    data: InitiateNewCycleRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/cycle`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
